module.exports = __webpack_public_path__ + "img/9788952228369.6d16ebbd.jpg";